import React from 'react'

const WorkerCookiesPolicy = () => {
    return (
        <div>WorkerCookiesPolicy</div>
    )
}

export default WorkerCookiesPolicy